<template>
    <div class="footer-text-box">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <div class="footer-text-box--content" v-html="content.text"></div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?6f711516